import mitt from 'mitt'

export default defineNuxtPlugin(() => {
  const emitter = mitt()

  return {
    provide: {
      emitterEmit: emitter.emit,
      emitterOn: emitter.on,
      emitterOff: emitter.off
    }
  }
})
